import { theme } from '@frameio/vapor';

export const highZIndexToDisplayDialogOverPopover =
  theme.zIndices.popover + 100;

export const higherZIndexToDisplayRoleDropdownOverDialog =
  highZIndexToDisplayDialogOverPopover + 1;
